document.addEventListener('click', function (e) {

  const button = e.target.closest('.z941409011-video-btn');
  if (!button) return;

  const wrapper = button.closest('.z941409011-video-auto-loop-wrap');
  const video = wrapper.querySelector('video');

  if (!video) return;

  if (video.paused) {
    video.play();
    button.textContent = 'STOP';
  } else {
    video.pause();
    button.textContent = 'PLAY';
  }

});